/* Early Black Friday — cart-drawer upsell card shows 2.0 Flavor Refills
   instead of the 1.0 "Pure Flavor Refills". Duplicated 2.0 product only.
   Rewrites the existing .cdc-upsell card in place: links, image, title, prices.
   The card's CTA is a plain link to the PDP, so nothing about the cart changes. */
(function () {
  'use strict';
  if (location.pathname.indexOf('breathefree-2-0-resistance-necklace-early-black-friday') === -1) return;

  var HANDLE = '2-0-flavor-refills';
  var TITLE = '2.0 Flavor Refills';
  var URL = '/products/' + HANDLE;
  var SALE = 29.95;        /* shop-currency price of the 2.0 pack */
  var COMPARE = 45.45;     /* shop-currency compare-at */
  var OLD_SALE = 29.95;    /* shop-currency price of the 1.0 pack the card ships with */
  var img = null;          /* filled from /products/<handle>.js */

  fetch(URL + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p) return;
      if (p.featured_image) img = p.featured_image;
      if (typeof p.price === 'number') SALE = p.price / 100;
      if (typeof p.compare_at_price === 'number' && p.compare_at_price > p.price) COMPARE = p.compare_at_price / 100;
      decorate();
    })
    .catch(function () {});

  /* keep whatever currency prefix / suffix the theme already rendered, swap the number */
  function reprice(text, shopAmount, factor) {
    var m = String(text).match(/([^0-9]*)([0-9][0-9.,]*)(.*)$/);
    if (!m) return null;
    var n = shopAmount * factor;
    var s = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return m[1] + s + m[3];
  }

  function num(text) {
    var m = String(text).match(/([0-9][0-9.,]*)/);
    return m ? parseFloat(m[1].replace(/,/g, '')) : 0;
  }

  function decorate() {
    var cards = document.querySelectorAll('.cdc-upsell');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-ebf-upsell') === '1') continue;

      var saleEl = card.querySelector('.cdc-upsell__sale');
      if (!saleEl) continue;                       /* not rendered yet */
      var factor = num(saleEl.textContent) / OLD_SALE || 1;

      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.setAttribute('href', URL);
        if (a.hasAttribute('aria-label')) a.setAttribute('aria-label', TITLE);
      });

      var name = card.querySelector('.cdc-upsell__name');
      if (name) name.textContent = TITLE;

      var im = card.querySelector('.cdc-upsell__media img');
      if (im && img) { im.setAttribute('src', img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200'); im.setAttribute('alt', TITLE); }
      else if (im) im.setAttribute('alt', TITLE);

      var saleTxt = reprice(saleEl.textContent, SALE, factor);
      if (saleTxt) {
        var inner = saleEl.querySelector('.money') || saleEl;
        inner.textContent = saleTxt;
      }

      var cmpEl = card.querySelector('.cdc-upsell__compare');
      if (cmpEl) {
        var cmpTxt = reprice(cmpEl.textContent, COMPARE, factor);
        if (cmpTxt) {
          var ci = cmpEl.querySelector('.money') || cmpEl;
          ci.textContent = cmpTxt;
        }
        cmpEl.style.display = COMPARE > SALE ? '' : 'none';
      }

      var saveEl = card.querySelector('.cdc-upsell__save');
      if (saveEl) {
        if (COMPARE > SALE) {
          saveEl.textContent = 'SAVE ' + Math.round((1 - SALE / COMPARE) * 100) + '%';
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }

      card.setAttribute('data-ebf-upsell', '1');
    }
  }

  var t = null;
  function schedule() { if (t) return; t = requestAnimationFrame(function () { t = null; decorate(); }); }

  function watch() {
    decorate();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('bf:bundle-added', schedule);
    document.addEventListener('click', schedule, true);
    setInterval(decorate, 900);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();